module.exports = __webpack_public_path__ + "media/customizations/babcockranch/logo-a84a31edef8c9eebfe3da48d2a89a4c2.png";